import { apiFetch } from "@/integrations/backend/client";

export type Faq = {
  id: string;
  question: string;
  answer: string;
  created_at: string;
};

export async function listFaqs(): Promise<Faq[]> {
  const res = await apiFetch("/api/v1/faqs", { method: "GET" });
  if (!res.ok) throw new Error(`faqs_list_failed:${res.status}`);
  return (await res.json()) as Faq[];
}

export async function createFaq(input: { question: string; answer: string }): Promise<Faq> {
  const res = await apiFetch("/api/v1/faqs", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
  if (!res.ok) throw new Error(`faq_create_failed:${res.status}`);
  return (await res.json()) as Faq;
}

export async function updateFaq(id: string, patch: Partial<Pick<Faq, "question" | "answer">>): Promise<Faq> {
  const res = await apiFetch(`/api/v1/faqs/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error(`faq_update_failed:${res.status}`);
  return (await res.json()) as Faq;
}

export async function deleteFaq(id: string): Promise<void> {
  const res = await apiFetch(`/api/v1/faqs/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error(`faq_delete_failed:${res.status}`);
}
